// components
import { Navbar1 } from '../../../components/navbars';
import BackToTop from '../../../components/BackToTop';
import PrivacyDetails from './privacyDetails';

const PrivacPolicy = () => {
    return (
        <>
            <div style={{ background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)" }} className=" position-relative ">
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-light zindex-10"
                    buttonClass="btn-outline-secondary btn-sm"
                />
            </div>
            <section
                style={{
                    background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                    padding: "80px 0",
                    textAlign: "center",
                    borderBottomLeftRadius: "30px",
                    borderBottomRightRadius: "30px",
                    marginLeft: 15,
                    marginRight: 15
                }}
            >
                <h1
                    style={{
                        fontSize: "48px",
                        fontWeight: "700",
                        color: "#1b1f29",
                    }}
                >
                    Privacy Policy
                </h1>

                {/* <p
                    style={{
                        marginTop: "10px",
                        fontSize: "18px",
                        color: "#6c757d",
                    }}
                >
                    Everything you need to know.
                </p> */}
            </section>
            <PrivacyDetails />
            <BackToTop />
        </>
    );
};

export default PrivacPolicy;
